import { useSnackbar } from 'notistack';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';

const CommonToast = () => {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const showToast = (message, variant = 'default') => {
    enqueueSnackbar(message, {
      variant,
      anchorOrigin: { vertical: 'top', horizontal: 'right' },
      action: (key) => (
        <IconButton
          onClick={() => closeSnackbar(key)}
          size="small"
          color="inherit"
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      ),
    });
  };

  return { showToast };
};

export default CommonToast;
